goog.provide("shadow.js.shim.module$src$svg$objects$database_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$database_svg");
shadow.js.shim.module$src$svg$objects$database_svg = shadow.js.nativeProvides["src/svg/objects/database.svg"] = shadow$bridge("src/svg/objects/database.svg");
module$shadow_js_shim_module$src$svg$objects$database_svg.default = shadow.js.shim.module$src$svg$objects$database_svg;
